import { LocalDate } from 'js-joda';
import { TockCookieName } from '@tock/shared/constants/browser-storage/TockCookies';
import { getCookie, setCookie } from '@tock/shared/utils/cookieUtils';
import { omitBy } from 'es-toolkit/compat';

export interface WalkinWaitlist {
  [businessId: number]: {
    partyId: number;
    serviceDate: string;
  };
}

export const WALKIN_WAITLIST_COOKIE = TockCookieName.WALKIN_WAITLIST;

export const setWaitlistCookie = (currWaitlist: WalkinWaitlist) => {
  setCookie(WALKIN_WAITLIST_COOKIE, currWaitlist);
};

// Keep this around through pushing the bug fix to maintain in flight walk ins
// After this goes out, this entire file can be removed.
export const clearOldWaitlistCookies = () => {
  let waitlistCookie = getWaitlistCookie();
  if (!waitlistCookie) {
    return;
  }

  waitlistCookie = omitBy(waitlistCookie, (val) =>
    LocalDate.now().isAfter(LocalDate.parse(val.serviceDate))
  );

  setCookie(WALKIN_WAITLIST_COOKIE, waitlistCookie);

  return waitlistCookie;
};

export const getWaitlistCookie = () => getCookie(WALKIN_WAITLIST_COOKIE);
